// TRONA - Auth0 Universal Login redirect
import { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import config from 'config/environment';
import { buildLoginRedirectOptions } from 'utils/authRedirect';

const DEFAULT_AUTH_RETURN_TO = '/empresa/home';
const PREVIEW_AUTH_CLIENT_ID = 'trona-preview-client';

function SignInDefault() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const redirectStartedRef = useRef(false);
  const hasAuth0Config = Boolean(
    config.auth0?.domain &&
      config.auth0?.clientId &&
      config.auth0.clientId !== PREVIEW_AUTH_CLIENT_ID
  );

  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated) {
      navigate(DEFAULT_AUTH_RETURN_TO, { replace: true });
      return;
    }

    if (!hasAuth0Config || redirectStartedRef.current) return;

    redirectStartedRef.current = true;
    loginWithRedirect(
      buildLoginRedirectOptions({
        pathname: DEFAULT_AUTH_RETURN_TO,
        search: '',
      })
    );
  }, [
    hasAuth0Config,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    navigate,
  ]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#fbfaff] px-6 dark:bg-neutral-950 dark:bg-[linear-gradient(180deg,#0d0f1a_0%,#151827_42%,#111827_100%)]">
      <div className="flex w-full max-w-sm flex-col items-center gap-5 text-center">
        <div className="rounded-2xl bg-white/95 px-5 py-4 shadow-[0_18px_42px_-26px_rgba(13,15,26,0.5)] ring-1 ring-neutral-200/80 dark:ring-white/20">
          <img
            src="/brand/full-logo.png"
            alt="TRONA"
            className="h-9 w-auto object-contain"
          />
        </div>

        <Loader2 className="h-7 w-7 animate-spin text-primary-500" />

        <div className="space-y-2">
          <h1 className="text-xl font-semibold text-neutral-900 dark:text-white">
            {hasAuth0Config
              ? 'Redirigiendo a Auth0'
              : 'Auth0 no esta configurado localmente'}
          </h1>
          <p className="text-sm text-neutral-500 dark:text-neutral-400">
            {hasAuth0Config
              ? 'Vas a iniciar sesion desde la pantalla segura de Auth0.'
              : 'Configura REACT_APP_AUTH0_DOMAIN y REACT_APP_AUTH0_CLIENT_ID para probar Universal Login en local.'}
          </p>
        </div>
      </div>
    </div>
  );
}

export default SignInDefault;
